import styled from '@emotion/styled';
import { Button, tokens } from '@hotjar/hotsauce';

import { SMART_PANEL_SPACING } from '../../constants-types/Layout';
import { smartPanelElementFullWidthStyles } from '../../utils/layout';

export const SmartPanelFullWidthButton = styled(Button)`
  margin: 0;
  ${smartPanelElementFullWidthStyles()};
  padding: 0 ${SMART_PANEL_SPACING};

  &&:focus {
    box-shadow: unset;
    border-color: ${tokens.color.ui_border_active};
  }
`;
